import React, { useRef, useEffect, useState } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBIcon,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
} from "mdb-react-ui-kit";

import { useLocation, useNavigate } from "react-router-dom";
import Table from "../Table";
import DataTable from "../DataTable";
import voucherDateAndTimeFormatter from "../../utilities/voucherDateAndTimeFormatter";
import NewRegisteredRequestDataTable from "./NewRegisteredRequestDataTable";
import axios from "axios";
import Loader from "../Loader";
import API_BASE_URL from "../../utilities/apiConfig";
import RejectedMembersDataTable from "./RejectedMembersDataTable";
import axiosInstance from "../../utilities/apiConfig";

const RejectedRequestDetails = () => {
  const [loading, setLoading] = useState(false);
  const [rejectedMembershipData, setRejectedMembershipData] = useState([]);

  // const navigate = useNavigate();
  // const location = useLocation();
  // const { NewRegistrationRequest } = location.state;

  const handleGetRejectedRegistrationRequest = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Registration/rejected_registration_requests`
      );

      console.log("rejected request data", response.data);
      if (response.data?.response?.statusCode === 200) {
        setRejectedMembershipData(response.data?.rejectedRequests);
      } else {
        setRejectedMembershipData([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const formatRegData = voucherDateAndTimeFormatter(rejectedMembershipData, [
    "appliedDate",
    "registrationDate",
    "rejectionDate",
    "appliedDate",
    "dateOfBirth",
    "mentorJoiningDate",
    "retirementYear",
  ]);

  const handleClick = (event, cellValues) => {
    console.log("button executed", cellValues);
  };

  const rejectedMembershipRequestColumns = [
    {
      field: "advocateBarId",
      headerName: "Registration No",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relationshipType",
      headerName: "Relationship Type",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relativeName",
      headerName: "Relative Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "mobileNo",
      headerName: "Mobile Number",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 180,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "appliedDate",
      headerName: "Applied Date",
      type: "text",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    // { field: 'requestedTimePeriodDate', headerName: 'Eligibility Date', type: 'text', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'daysLeft', headerName: 'Days Left', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'permanentAddress', headerName: 'Permanent Address', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'status', headerName: 'Status', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'remark', headerName: 'Remark', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    {
      field: "rejectionDate",
      headerName: "Rejection Date",
      type: "text",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "userName",
      headerName: "Rejected By",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    // { field: 'rejectedRequestId', headerName: 'Rejected Request ID', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'registrationDate', headerName: 'Registration Date', type: 'text', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'barAssociationId', headerName: 'Bar Association ID', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'bloodGroup', headerName: 'Blood Group', minWidth: 100, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'chamberNo', headerName: 'Chamber No', minWidth: 100, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'dateOfBirth', headerName: 'Date of Birth', type: 'text', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'isPreviousDepartment', headerName: 'Previous Department', type: 'boolean', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'mentorAdvocateBarId', headerName: 'Mentor Advocate Bar ID', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'mentorAdvocateName', headerName: 'Mentor Advocate Name', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'mentorJoiningDate', headerName: 'Mentor Joining Date', type: 'text', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'previousDepartment', headerName: 'Previous Department Name', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'retirementYear', headerName: 'Retirement Year', type: 'text', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'userId', headerName: 'User ID', minWidth: 250, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'aadharDocument', headerName: 'Aadhar Document Path', minWidth: 300, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'affidavitDocument', headerName: 'Affidavit Document Path', minWidth: 300, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'aibeCertificate', headerName: 'AIBE Certificate Path', minWidth: 300, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'doctorateDocument', headerName: 'Doctorate Document Path', minWidth: 300, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'graduationDocument', headerName: 'Graduation Document Path', minWidth: 300, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'highschoolDocument', headerName: 'High School Document Path', minWidth: 300, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'intermediateDocument', headerName: 'Intermediate Document Path', minWidth: 300, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'postGraduationDocument', headerName: 'Post Graduation Document Path', minWidth: 300, flex: 1, align: 'left', headerAlign: 'left' }
  ];

  useState(() => {
    handleGetRejectedRegistrationRequest();
  }, []);
  return (
    <>
      {loading && <Loader />}
      <MDBContainer fluid>
        {/* <MDBRow className="bg-primary text-white py-3">
        <MDBCol md="8" className="d-flex align-items-center">
          <img src={baricon} alt="Dashboard Icon" className="me-2" style={{ width: '48px' }} />
          <h4>Bar Association Dehradun</h4>
        </MDBCol>
        <MDBCol className="d-flex align-items-center justify-content-end">
          <img src={proficon} alt="Dashboard Icon" className="me-2" style={{ width: '48px' }} />
          <div>
            <h6 className="text-center">SUPER ADMIN</h6>
            <div outline color="light" size="sm" className="ms-2 text-center">
              Logout
            </div>
          </div>
        </MDBCol>
      </MDBRow> */}

        <RejectedMembersDataTable
          TableData={formatRegData}
          tableName="Rejected Registration Requests"
          TableColumns={rejectedMembershipRequestColumns}
          height={750}
        />
      </MDBContainer>
    </>
  );
};

export default RejectedRequestDetails;
